module.exports = __webpack_public_path__ + "static/media/餛飩湯.bc9af7d8.jpg";